import React from 'react';
import './App.css';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { FlightBookingForm } from './components/FlightBookingForm';
import { HotelBooking } from './components/HotelBooking';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { VisitorCounter } from './components/VisitorCounter';
import { Footer } from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <FlightBookingForm />
        <HowItWorks />
        <HotelBooking />
        <Testimonials />
        <FAQ />
        <VisitorCounter />
      </main>
      <Footer />
    </div>
  );
}

export default App;

